// extracted by mini-css-extract-plugin
module.exports = {"banner":"News-module--banner--1g6-I","textBanner":"News-module--textBanner--3fnet"};